import { deleteSede } from "../respository/sede.repository"

export const DeleteSede = async(sedeId) => {
  try {
    const response = await deleteSede(sedeId)
    return response.data
  } catch (error) {
    return error.response.data 
  }
}